import { useRef } from 'react';
import { SearchFacet } from '#server/models';
import { LandingLayout } from '@/layouts';
import { Heading, SearchBar, QuickLinks, QuickLink, QuickLinkProps, SearchTabs } from '@/components';
import { useSearchContext } from '@/context';
import { trackGAEvent } from '@/services';

// TODO: Make this come from cms/config
const quickLinks: QuickLinkProps[] = [
  { to: 'https://staffportal.curtin.edu.au/', label: 'Staff Portal', showIcon: true },
  { to: 'https://oasis.curtin.edu.au/', label: 'Oasis', showIcon: true },
  { to: 'http://scholarships.curtin.edu.au/', label: 'Scholarships' },
  { to: 'https://www.curtin.edu.au/study/applying/domestic/how-to-apply/', label: 'How to apply' },
];

export const Landing = () => {
  const { setFacet, searchQuery } = useSearchContext();

  const handleTabClick = (value: SearchFacet) => {
    trackGAEvent({
      event: 'search_facet_selected',
      search_facet: value,
      search_term: searchQuery ?? '',
      search_facet_click_count: 1,
    });
    setFacet(value);
  };

  const tabsRef = useRef<HTMLDivElement>(null);

  return (
    <LandingLayout>
      <div className="mx-auto flex w-full max-w-screen-lg flex-col items-start gap-8 px-5 pt-10 md:my-auto md:gap-10 md:p-16">
        <Heading variant="h2" className="block w-fit leading-8 sm:leading-[46px]">
          Explore Curtin University
        </Heading>
        <SearchTabs handleTabClick={handleTabClick} ref={tabsRef} />
        <SearchBar clickableAreaRefs={[tabsRef]} />
        <QuickLinks landing>
          {quickLinks.map((link) => (
            <QuickLink key={link.label} to={link.to} label={link.label} showIcon={link.showIcon} />
          ))}
        </QuickLinks>
      </div>
    </LandingLayout>
  );
};
